export interface BaseModel {
    id: number;
    createdDate: string;
    modifiedDate?: string;
    createdById?: number;
    modifiedById?: number;
}

export interface SiteBaseModel extends BaseModel {
    isActiveRecord: boolean;
    name: string;
    fullName: string;
    bpLocationId: number;
    state: string;
    bpsid: number;
    automedSiteId?: number;
    umbracoSiteId: string;
}

/** namespace Myhealth.ERP.Logic.Models */
export interface AutomedSiteModel {
    centerName: string;
    locationDisplayName: string;
    confirmAppInfo: string;
    confirmAppHolidayInfo: string;
    futureApptWeeks: number;
    blockUnpaidBooking: boolean;
    aobEnabled: boolean;
    aobIntroTemplate: string;
    aobDeclineTemplate: string;
}

export const enum ConfigFlagEnum {
    SelfCheckinFluPrescreening = 'SelfCheckinFluPrescreening',
    EnableAutomedScripts = 'EnableAutomedScripts',
    EnableAutomedReferrals = 'EnableAutomedReferrals',
    AutomedUrlPath = 'AutomedUrlPath',
}

export interface SiteConfig {
    value?: number;
    defaultValue?: number;
    textValue?: string;
    defaultTextValue?: string;
    id: ConfigFlagEnum;
    description: string;
}
